View = require 'view'
template = require 'views/templates/header_info_menu'
tipTemplate = require 'views/templates/tip'
track = require 'debug/track'
filteredTips = require 'lib/filtered-tips'

module.exports = class HeaderInfoMenuView extends View
  viewTitleKey: 'information'

  events:
    'click .js-new-tip': 'newTipEvent'
    'click .js-tip': 'clickTip'
    'click .js-meta-page-link': 'clickMetaPage'
    'click .js-more-menu-button': 'showMoreLinks'

  initialize: ->
    @remainingTips = filteredTips.slice(0)
    super

  render: ->
    @$el.html template()
    @newTip()
    @

  # Get a new random tip and cycle the array when empty.
  # Adapted from http://stackoverflow.com/a/17891411
  getFreshTip: ->
    if @remainingTips.length < 1
      @remainingTips = filteredTips.slice(0)
    index = Math.floor(Math.random() * @remainingTips.length)
    item = @remainingTips[index]
    @remainingTips.splice index, 1
    item

  newTipEvent: ->
    track("Header Tips", "Get a new tip.")
    @newTip()
    return

  newTip: ->
    tip = @getFreshTip()
    @$('.js-fill-tip').empty().append tipTemplate(tip)
    track("Header Tips", tip.id, "Viewed")
    @

  clickTip: (e) ->
    id = @$(e.currentTarget).attr('data-tipid')
    track("Header Tips", id, "Clicked")

  clickMetaPage: (e) ->
    page = @$(e.currentTarget).attr('data-metapagename')
    track("Header", "Information Menu", page)

  showMoreLinks: (e) ->
    @$('.js-more-menu-button').addClass('hide')
    @$('.js-more-menu').removeClass('hide')
    track("Header", "Information Menu", "Show More Links")



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-info-menu-view.coffee